import { ListingStatuses, ListingVisibility, listingVisibility } from "./../sharedSchema";

export const status = ListingStatuses;

export type Status = typeof status[number];

export const visibleListingStatus: Status[] = ["onSale", "inNegotiation"];

export const invisibleListingStatus: Status[] = ["sold", "removed", "frozen"];

/**
 * The listing-type / listing-state unions are defined in `sharedSchema.ts` so
 * the server types these listing fields identically. Re-exported here (values
 * included — the const arrays are iterated to build form dropdowns) so existing
 * imports keep working.
 */
export {
  residentialListingType,
  commercialListingType,
  listingType,
  listingState
} from "./../sharedSchema";

export type {
  ResidentialListingType,
  CommercialListingType,
  ListingType,
  ListingState
} from "./../sharedSchema";

export const visibility = listingVisibility;

export type Visibility = ListingVisibility;
